import "core-js/modules/es.array.concat.js";
import QRCode from 'qrcodejs2';
import http from '@/utils/http';
import { Search } from '@element-plus/icons-vue';
export default {
  setup: function setup() {
    return {
      Search: Search
    };
  },
  components: {
    Search: Search
  },
  data: function data() {
    return {
      bwidth: true,
      //判断页面的宽度
      customerData: [],
      //客户名称
      ewmShow: false,
      //二维码链接显示状态
      // 页面修改新增验证规则
      rules: {
        orderno: [{
          required: true,
          message: '订单编号不能为空',
          trigger: 'blur'
        }]
      },
      formInline: {
        orderno: '',
        company: '',
        lianjie: ''
      }
    };
  },
  created: function created() {
    this.customerList();

    if (window.screen.availWidth < 800) {
      //判断屏幕小于800时
      this.bwidth = false;
    }
  },
  methods: {
    // 客户数据
    customerList: function customerList() {
      var _this = this;

      http.get("/oa/customer").then(function (res) {
        var _res$data = res.data,
            data = _res$data.data,
            code = _res$data.code;

        if (200 == code) {
          _this.customerData = data;
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.ruleFormRef.validate(function (valid) {
        if (valid == false) {
          return;
        } else {
          if (_this2.ewmShow) {
            _this2.$refs.exCodeRef.innerHTML = "";
          }

          _this2.ewmShow = true;
          var _this2$formInline = _this2.formInline,
              orderno = _this2$formInline.orderno,
              company = _this2$formInline.company;

          _this2.$nextTick(function () {
            var sun = "http://jhderp.smtjhd.com:6066/survey/index.html#/login?orderno=".concat(orderno, "&company=").concat(company);
            _this2.formInline.lianjie = sun;
            var qrcode = new QRCode(document.getElementById('ewm1'), {
              text: sun,
              width: 150,
              height: 150,
              correctLevel: QRCode.CorrectLevel.L
            });
          });
        }
      });
    }
  }
};